export function view(value) {
  return value === 'cbs' ? 'Cbs' : 'Greyfinch'
}
